
import { defineComponent } from "vue";
import { mapState } from "vuex";

import RGPDLink from "@/components/RGPDLink.vue";
import GcuLink from "@/components/gcuLink.vue";
import { State } from "@/store";

export default defineComponent({
    name: "Signup",
    components: {
        GcuLink,
        RGPDLink
    },
    computed: {
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject,
            authenticated: (state: State) => state.auth.authenticated
        })
    },
    mounted() {

        if (this.authenticated) {
            this.$router.replace("Upload");
        }
    }
});
